import styled from 'styled-components'
import { COLOURS } from 'resources'
import { ReactComponent as ClosedIcon } from 'resources/images/icons/shares-closed.svg'
import { ReactComponent as InfoGreyIcon } from 'resources/images/icons/info-grey.svg'

export const CenterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOURS.neutralGrey1};
  align-items: left;
  justify-content: left;
  padding: 25px 20px;
  max-width: 280px;
  gap: 20px;
  border-radius: 8px;
`

export const SharesClosedIconContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`
export const SharesClosedIcon = styled(ClosedIcon)`
  width: 65px;
  height: 70px;
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  font-weight: 700;
  font-size: 26px;
  line-height: 26px;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
`

export const Text = styled.span`
  font-family: 'EBGaramond', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
`

export const BoldText = styled(Text)`
  font-weight: 600;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`

export const InfoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  padding-top: 2px;
`

export const InfoIcon = styled(InfoGreyIcon)`
  width: 18px;
  height: 18px;
  path {
    fill: ${COLOURS.neutralBlack};
  }
`
